// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar {
  border-radius: 50%;
  font-size: 12px;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
}
.avatar .main-image {
  max-width: 100%;
  border-radius: 100%;
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.default-img img {
  max-width: 100%;
  border-radius: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/hrone-ui-library/hrone-avatar/hrone-avatar.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AAAI;EAEI,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AACR;;AAII;EAEI,eAAA;EACA,mBAAA;AAFR","sourcesContent":[".avatar{\n    border-radius: 50%;\n    font-size: 12px;\n    color: white;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: normal;\n    .main-image\n    {\n        max-width: 100%;\n        border-radius: 100%;\n        object-fit: cover;\n        height: 100%;\n        width: 100%;\n      }\n}\n.default-img\n{\n    img\n    {\n        max-width: 100%;\n        border-radius: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
